var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPsycholath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.14 153.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 3.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.76,111.86l4.61,4.61c4.84,4.84,11.4,7.56,18.25,7.56h23.78c6.49,0,11.63-5.47,11.24-11.95-.43-7.19-.53-15.25,1.01-16.8,2.9-2.9,12.73-1.22,12.73-7.87,0-9.83-13.59-16.85-13.59-28.65C115.79,26.81,89.49.98,57.35,1.77,27.23,2.5,2.65,26.96,1.77,57.07c-.28,9.72,1.87,18.92,5.89,27.02,7.47,15.06,10.96,31.78,9.56,48.53l-1.6,19.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.6,
    y1: 124.03,
    x2: 83.6,
    y2: 151.75
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.1 52.52 64.79 52.52 64.79 24.85 34.45 65.02 52.76 65.02 52.76 92.69 83.1 52.52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPsycholath);
export default __webpack_public_path__ + "static/media/icon-psycholath.75fc7ac504c0c915d3f886a1d53afea2.svg";
export { ForwardRef as ReactComponent };